import { Box, Tooltip } from '@mantine/core'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

interface EndedTooltipProps {
  ended: boolean
  fullWidth?: boolean
  children: ReactNode
}

/**
 * Explains why an action is disabled on an ended trade show.
 * The wrapper receives the hover events because disabled buttons do not fire them.
 */
export function EndedTooltip({ ended, fullWidth, children }: EndedTooltipProps) {
  const { t } = useTranslation()

  return (
    <Tooltip label={t('tradeshow.ended-tooltip')} disabled={!ended} withArrow withinPortal position="bottom">
      <Box component="span" sx={{ display: fullWidth ? 'block' : 'inline-flex' }}>
        {children}
      </Box>
    </Tooltip>
  )
}
